module.exports = __webpack_public_path__ + "static/media/Y1.29496341.mp3";